import React, { FC } from 'react';
import {
  Filter,
  ReferenceInput,
  TextInput,
  FilterProps,
  SelectInput,
} from 'react-admin';
import { LazyReferenceInput } from 'components/LazyAutoCompleteInput';
import { SupervisorReferenceInput } from 'components/SupervisorReferenceInput';

export const PreRockSheetFilter: FC<FilterProps> = props => (
  <Filter {...props}>
    <SupervisorReferenceInput
      label="Supervisor"
      source="supervisorUserIds||$cont"
    />
    <TextInput
      label="Lot"
      source="jobLot||$eq"
      alwaysOn
      resettable
      data-cy="ProdPayMasterSheetSheetFilterLot"
    />
    <LazyReferenceInput
      label="Builder"
      source="builderId"
      reference="builder"
      filterToQuery={value => (value ? { name: value } : {})}
      sort={{ field: 'name', order: 'ASC' }}
      optionText="name"
      optionValue="id"
    />
    <LazyReferenceInput
      label="Subdivision"
      source="subdivisionId"
      reference="subdivision"
      resettable
      alwaysOn
      allowEmpty={false}
      filterToQuery={value => (value ? { name: value } : {})}
      sort={{ field: 'name', order: 'ASC' }}
      optionText="name"
      optionValue="id"
    />
    <ReferenceInput
      label="Phase"
      source="currentPhaseId"
      reference="phase"
      perPage={Number.MAX_SAFE_INTEGER}
      sort={{ field: 'priority', order: 'ASC' }}
      allowEmpty={false}
      resettable
      alwaysOn
    >
      <SelectInput optionText="name" optionValue="id" />
    </ReferenceInput>
    <TextInput
      label="Address"
      alwaysOn
      resettable
      source="address1||$cont"
      data-cy="address1Filter"
    />
  </Filter>
);
